import React from "react";
import { clsx } from "clsx";

export type BadgeVariant = "default" | "success" | "warning" | "danger";

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

const variants: Record<BadgeVariant, string> = {
  default: "bg-default-99 text-gray-700",
  success: "bg-green-100 text-green-700",
  warning: "bg-yellow-100 text-yellow-700",
  danger: "bg-red-100 text-red-700",
};

export const Badge: React.FC<BadgeProps> = ({ children, variant = "default", className }) => (
  <span
    className={clsx(
      "inline-flex items-center rounded px-2 py-0.5 text-xs font-medium",
      variants[variant],
      className
    )}
  >
    {children}
  </span>
);
